/* eslint-disable react/no-multi-comp */

import React, { Component } from "react";
import "./project_styles.css";
import Assignment from "material-ui/svg-icons/action/assignment";
import Avatar from "material-ui/Avatar";
import FileFolder from "material-ui/svg-icons/file/folder";
import {firebaseApp} from "../../firebase/firebase";
import FlatButton from "material-ui/FlatButton";
import IconButton from "material-ui/IconButton";
import Send from "material-ui/svg-icons/content/send";
import TextSms from "material-ui/svg-icons/communication/textsms";
import AttachFile from "material-ui/svg-icons/editor/attach-file";
import {
  createTask,
  deleteTask,
  fetchTaskQueue,
  fetchTaskQueueRealtor,
  handleDeleteFile,
  handleFiles,
  markDone,
  selectTask,
  sendMessage,
  sendNotification,
  stopOnboarding,
  uploadFile
} from "./project_actions";
import {
  restartTimer,
  setTimerTask,
  startTimer
} from "../timetracker/timer_actions";
import { connect } from "react-redux";
import { Grid, Row, Col } from "react-bootstrap";
import { Tabs, Tab } from "material-ui/Tabs";
import FormDialog from "./project_dialog";
import DeleteDialog from "./delete_task_dialog";
import OnboardingDialog from "./start_onboarding_dialog";
import Joyride from "react-joyride";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      openDialog: false,
      project: "",
      newTask: "",
      newDescription: "",
      newTitle: "",
      newMessage: "",
      run: false,
      steps: [
        {
          target: ".first-step",
          content: (
            <div style={{ textAlign: "left" }}>
              This section is the task panel. Every task that gets created will
              be listed right here. <br /> <br />{" "}
              <b>
                Click on the task you just created to see it's contents then
                press next!
              </b>
            </div>
          ),
          spotlightClicks: true,
          placement: "right",
          title: "Task Panel"
        },
        {
          target: ".second-step",
          content:
            "This is the main section of the application. From here you can add files and attachments, and also communicate with your virtual assistant",
          placement: "bottom",
          title: "Main Section"
        },
        {
          target: ".third-step",
          content: "Messages to and from your assistant will appear here",
          placement: "left",
          title: "Virtual Assistant Messenger"
        },
        {
          target: ".fourth-step",
          content: "Send a message to your assistant now, then press next!",
          spotlightClicks: true,
          placement: "top",
          title: "Enter A Message"
        },
        {
          target: ".fifth-step",
          content:
            "This area has the details of your task. Keep this as updated as possible!",
          placement: "left",
          title: "Task Detais"
        },
        {
          target: ".sixth-step",
          content:
            "We hope you enjoy your experience with us. If you have ANY questions, please feel free to reach out to us at support@mymozak.com!",
          placement: "bottom",
          title: "Thats all folks!"
        }
      ]
    };
  }

  componentDidMount() {
    const props = this.props;
    if (this.props.realtor) {
      props.fetchTaskQueueRealtor();
    } else {
      props.fetchTaskQueue(this.props.specialty);
    }
  }

  handleOpen = () => {
    this.setState({ openDialog: true });
  };

  handleClose = () => {
    this.setState({ openDialog: false });
  };

  handleSubmit = () => {
    this.props.sendMessage(
      this.state.newMessage,
      this.props.user.uid,
      this.props.activeTask
    );
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    this.setState({ newMessage: "" });
  };

  handleSubmitSms = () => {
    console.log('coming soon')
  }

  handleCompletedTask = () => {
    const { key, userEmail, userId, title, } = this.props.activeTask;
    const sendNotification = firebaseApp.functions().httpsCallable('taskDoneNotification')
    console.log(sendNotification(userEmail))
    /*this.props.markDone(this.props.activeTask);
    this.props.sendNotification(
      this.props.activeTask,
      "Your task is complete! Please review."
    );*/
  };

  handleAttachDocument = e => {
    this.props.handleFiles(e.target.files[0], this.props.activeTask);
  };

  handleSelectTask = task => {
    this.props.selectTask(task)
  }

  beginTimer = () => {
    const { key, userEmail, userId, title } = this.props.activeTask;
    const update = {};
    update[`tasks/${key}/inProgressUser`] = this.props.user.email;
    update[`tasks/${key}/users/${this.props.user.uid}`] = true;
    firebaseApp
      .database()
      .ref()
      .update(update);
    this.props.setTimerTask(userEmail, userId, key, title);
    if (this.props.isActiveTimer) {
      this.props.restartTimer();
    } else {
      this.props.startTimer();
    }
  };

  startOnboarding = () => {
    this.setState({ run: true });
  };

  render() {
    return (
      <Grid fluid className="sixth-step">
        <Joyride
          steps={this.state.steps}
          run={this.state.run}
          showProgress
          showSkipButton
          continuous
        />
        <Row>
          <Col
            sm={3}
            className="taskTray raised first-step"
            style={
              this.props.realtor
                ? { height: window.innerHeight - 100 }
                : { height: window.innerHeight - 220 }
            }
          >
            <div>
              {!this.props.realtor ? (
                <Tabs
                  inkBarStyle={{ backgroundColor: "#455A64" }}
                  tabItemContainerStyle={{
                    backgroundColor: "#ffffff",
                    marginTop: 20
                  }}
                  initialSelectedIndex={0}
                >
                  <Tab
                    onActive={() => {
                      !this.props.realtor
                        ? this.props.fetchTaskQueue(this.props.specialty)
                        : this.props.fetchTaskQueueRealtor();
                    }}
                    label="All Tasks"
                    style={{ color: "black", fontSize: 13 }}
                  />
                  <Tab
                    onActive={() =>
                      this.props.fetchTaskQueue(
                        this.props.specialty,
                        true,
                        false,
                        this.props.user.email
                      )
                    }
                    label="Assigned"
                    style={{ color: "black", fontSize: 13 }}
                  />
                  <Tab
                    onActive={() =>
                      this.props.fetchTaskQueue(
                        this.props.specialty,
                        true,
                        true,
                        this.props.user.email
                      )
                    }
                    label="Done"
                    style={{ color: "black", fontSize: 13 }}
                  />
                </Tabs>
              ) : null}
              {this.props.taskQueue.map((task, i) => {
                return (
                  <div
                    key={i}
                    className={this.props.activeTask.key === task.key ? "taskDone": "taskCard"}
                    onClick={() => this.handleSelectTask(task)}
                  >
                    <Avatar
                      icon={<Assignment />}
                      backgroundColor="#555555"
                      size={20}
                    />
                    <div className="taskCardInner">
                      <p className="taskRealtor">
                        <b>Task:</b>{" "}
                        {task.title.charAt(0).toUpperCase() +
                          task.title.slice(1)}
                      </p>
                      <p className="taskRealtor">
                        <b>Realtor:</b>{" "}
                        {task.userEmail.charAt(0).toUpperCase() +
                          task.userEmail.slice(1)}
                      </p>
                      <p className="taskRealtor">
                        <b>Details:</b>{" "}
                        {task.details.charAt(0).toUpperCase() +
                          task.details.slice(1)}
                      </p>
                      {task.type ? (
                        <p className="chipText raised">
                          {task.type.charAt(0).toUpperCase() +
                            task.type.slice(1)}
                        </p>
                      ) : null}
                    </div>
                  </div>
                );
              })}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center"
                }}
              >
                <FormDialog createTask={this.props.createTask} />
                &nbsp;
                <DeleteDialog
                  tasks={this.props.taskQueue}
                  deleteTask={this.props.deleteTask}
                />
              </div>
            </div>
          </Col>
          <Col sm={9}>
            {Object.keys(this.props.activeTask).length === 0 &&
            this.props.activeTask.constructor === Object ? (
              <div
                className="mainContent raised second-step"
                style={
                  this.props.realtor
                    ? { height: window.innerHeight - 100 }
                    : { height: window.innerHeight - 220 }
                }
              >
                <p className="noTaskSelected">
                  Greetings! Select a Task from the left
                </p>
              </div>
            ) : (
              <Row
                className="mainContent second-step raised"
                style={
                  this.props.realtor
                    ? { height: window.innerHeight - 100 }
                    : { height: window.innerHeight - 220 }
                }
              >
                <Col className="third-step messengerArea" sm={7}>
                  <div
                    className="messengerBody"
                    style={
                      this.props.realtor
                        ? { height: window.innerHeight - 180 }
                        : { height: window.innerHeight - 320 }
                    }
                  >
                    {!this.props.activeTask.messages
                      ? null
                      : Object.values(this.props.activeTask.messages).map(
                          message => {
                            return (
                              <div key={message._id}>
                                {message.user._id === this.props.user.uid ? (
                                  <p className={"messageRight"}>
                                    {message.text}
                                    <br />
                                    <span style={{ fontSize: 10 }}>
                                      {new Date(
                                        message.createAt
                                      ).toLocaleDateString("en-US")}
                                    </span>
                                  </p>
                                ) : (
                                  <p className={"messageLeft"}>
                                    {message.text}
                                    <br />
                                    <span style={{ fontSize: 10 }}>
                                      {new Date(
                                        message.createAt
                                      ).toLocaleDateString("en-US")}
                                    </span>
                                  </p>
                                )}
                              </div>
                            );
                          }
                        )}
                    <div
                      style={{
                        float: "left",
                        clear: "both",
                        backgroundColor: "blue",
                        marginTop: 50
                      }}
                      ref={end => {
                        this.messagesEnd = end;
                      }}
                    />
                  </div>
                  <div className=" fourth-step messengerBar raised">
                    <input
                      ref={r => {
                        this.newMessageInput = r;
                      }}
                      value={this.state.newMessage}
                      className="inputMessage"
                      type="text"
                      placeholder="Message"
                      onChange={e =>
                        this.setState({ newMessage: e.target.value })
                      }
                    />
                    <IconButton
                      disabled={
                        (this.props.activeTask.inProgressUser !==
                          this.props.user.email &&
                          this.props.activeTask.userEmail !==
                            this.props.user.email) ||
                        this.props.activeTask.done
                      }
                    >
                      <AttachFile />
                      <input
                        className="uploadInput"
                        type="file"
                        onChange={this.handleAttachDocument}
                      />
                    </IconButton>
                    
                    {!this.props.realtor ? <IconButton
                      disabled={
                        !this.state.newMessage ||
                        (this.props.activeTask.inProgressUser !==
                          this.props.user.email &&
                          this.props.activeTask.userEmail !==
                            this.props.user.email) ||
                        this.props.activeTask.done
                      }
                      onClick={this.handleSubmitSms}
                    >
                      <TextSms />
                    </IconButton> : null}
                    
                    <IconButton
                      disabled={
                        !this.state.newMessage ||
                        (this.props.activeTask.inProgressUser !==
                          this.props.user.email &&
                          this.props.activeTask.userEmail !==
                            this.props.user.email) ||
                        this.props.activeTask.done
                      }
                      onClick={this.handleSubmit}
                    >
                      <Send />
                    </IconButton>
                  </div>
                </Col>
                <Col sm={5} className="fifth-step">
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: 300,
                      color: "#000000",
                      display: "inline-block",
                      marginTop: 20
                    }}
                  >
                    Task Title
                  </p>
                  <p className="taskTitleContainer">
                    {this.props.activeTask.title
                      ? this.props.activeTask.title.charAt(0).toUpperCase() +
                        this.props.activeTask.title.slice(1)
                      : "No Title"}
                  </p>
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: 300,
                      color: "#000000",
                      display: "inline-block"
                    }}
                  >
                    Due Date
                  </p>
                  <p className="dueDate">
                    {this.props.activeTask.dueDate
                      ? this.props.activeTask.dueDate
                      : "No Due Date"}
                  </p>
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: 300,
                      color: "#000000",
                      display: "inline-block"
                    }}
                  >
                    Details
                  </p>
                  <p className="descriptionContainer">
                    {this.props.activeTask.details
                      ? this.props.activeTask.details
                      : `No Details`}
                  </p>
                  <div style={{ marginBottom: 24 }}>
                    <p
                      style={{
                        fontSize: 20,
                        fontWeight: 300,
                        color: "#000000",
                        display: "inline-block"
                      }}
                    >
                      {" "}
                      Attachments
                    </p>
                    {!this.props.activeTask.files ? (
                      <div className="attachmentContainer"> No Attachments</div>
                    ) : (
                      <div className="attachmentContainer">
                        {Object.values(this.props.activeTask.files).map(
                          (file, i) => {
                            return (
                              <div key={i} className="attachmentCard">
                                <Avatar
                                  icon={<FileFolder />}
                                  backgroundColor="#555555"
                                  size={20}
                                />
                                <div className="taskCardInner">
                                  <span>
                                    {file.name}
                                    <a
                                      className="smallText"
                                      href={file.link}
                                      download
                                    >
                                      {" "}
                                      Download{" "}
                                    </a>
                                    <a
                                      className="smallText"
                                      href="#"
                                      onClick={() =>
                                        this.props.handleDeleteFile(
                                          file,
                                          this.props.activeTask
                                        )
                                      }
                                    >
                                      Delete File
                                    </a>
                                  </span>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    )}
                    <div className="taskActions">
                      {/*<FlatButton
                          backgroundColor="#90caf9"
                          containerElement="label"
                          label={"Attach File"}
                          fullWidth={false}
                          labelStyle={{ fontSize: 12 }}
                          style={{ margin: 11 }}
                          disabled={
                            (this.props.activeTask.inProgressUser !==
                              this.props.user.email || this.props.activeTask.done) && (!this.props.realtor)
                          }
                        >
                          <input
                            className="uploadInput"
                            type="file"
                            onChange={this.handleAttachDocument}
                          />
                        </FlatButton>*/}
                      {!this.props.realtor ? (
                        <FlatButton
                          backgroundColor="#90caf9"
                          label={"Start Working"}
                          disabled={
                            !this.props.canStartTimer ||
                            this.state.realtor ||
                            this.props.activeTask.done
                          }
                          fullWidth={false}
                          labelStyle={{ fontSize: 12 }}
                          style={{ margin: 11 }}
                          onClick={this.beginTimer}
                        />
                      ) : null}
                      {!this.props.realtor ? (
                        <FlatButton
                          backgroundColor="#90caf9"
                          label={"Mark As Done"}
                          disabled={
                            this.props.activeTask.inProgressUser !==
                              this.props.user.email ||
                            this.props.activeTask.done
                          }
                          fullWidth={false}
                          labelStyle={{ fontSize: 12 }}
                          style={{ margin: 11 }}
                          onClick={this.handleCompletedTask}
                        />
                      ) : null}
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        <OnboardingDialog
          startOnboarding={this.startOnboarding}
          showDialog={this.props.onboarding}
          stopOnboarding={this.props.stopOnboarding}
        />
      </Grid>
    );
  }
}

const mapStateToProps = ({ projects, timer, auth }) => {
  const { newTask, modalTask, taskQueue, notifications, activeTask } = projects;
  const { canStartTimer, isActiveTimer, project } = timer;
  const { user, realtor, specialty, onboarding } = auth;
  return {
    activeTask,
    canStartTimer,
    isActiveTimer,
    modalTask,
    newTask,
    notifications,
    onboarding,
    project,
    realtor,
    specialty,
    taskQueue,
    user
  };
};

export default connect(
  mapStateToProps,
  {
    createTask,
    deleteTask,
    fetchTaskQueue,
    fetchTaskQueueRealtor,
    handleDeleteFile,
    handleFiles,
    markDone,
    restartTimer,
    selectTask,
    sendMessage,
    sendNotification,
    setTimerTask,
    startTimer,
    stopOnboarding,
    uploadFile
  }
)(Projects);



// WEBPACK FOOTER //
// ./src/components/project/index.js